import httpService from '../../services/httpService';

export const fetchEquipments = async (organization_id) =>  {
  const response = await httpService.get(
    `/api/v4/equipments/automatic?organization_id=${organization_id}}`
  );

  return response.data;
}

export const fetchAreas = async (organization_id) => {
  const response = await httpService.get(
    `/api/v4/areas?organization_id=${organization_id}`
  );

  return response.data;
}

export const fetchIrrigations = async (organization_id) => {
  const response = await httpService.get(
    `/api/v4/irrigation_managements?organization_id=${organization_id}`
  );
  return response.data
    .sort((a, b) => a.name.localeCompare(b.name));
}

export const buildQueryWithBrackets = (params) => {
  const query = []

  Object.entries(params).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      value.forEach((v) => {
        query.push(`${encodeURIComponent(key)}[]=${encodeURIComponent(v)}`)
      })
    } else {
      query.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
    }
  })

  return query.join('&')
}
